// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__no329","question":"styles_question__KE8T0","inputVisibleButton":"styles_inputVisibleButton__3LMwO","note":"styles_note__2ZwB-"};